import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getConfig: () => ({
    url: 'baseInfo/api/v1/config',
    method: 'GET',
  }),
  getPublicConfig: () => ({
    url: 'baseInfo/api/v1/config/public',
    method: 'GET',
  }),
  getBannerList: () => ({
    url: 'baseInfo/api/v1/banner',
    anonymousUrl: 'baseInfo/anonymous/api/v1/general/banner',
    method: 'get',
  }),
  getStories: () => ({
    url: 'baseInfo/anonymous/api/v1/general/stories',
    method: 'GET',
  }),
  addSlideVisit: (input) => ({
    url: 'baseInfo/api/v1/stories/addSlideVisit',
    method: 'POST',
    data: input,
  }),
  getFAQShortAnswer: (input) => ({
    url: 'baseInfo/anonymous/api/v1/general/faq/category',
    method: 'GET',
    params: input,
  }),
  getLanding: () => ({
    url: 'baseInfo/anonymous/api/v1/general/landing/lastActive',
    method: 'GET',
  }),
};

export default apis;
